import React, {PropTypes} from 'react';
import {Link} from 'react-router';

const CollectionLayout = ({changeView,toggleFilter,firstRecipe}) => {
	let iconGrid = require('../../images/ui-sort-grid.png');
	let iconList = require('../../images/ui-sort-list.png');
	let iconSlideshow = require('../../images/ui-sort-slideshow.png');
	let iconFilter = require('../../images/ui-search-lime-expanded.png');
	
	return(
		<div className="filter-panel">
			<div className="layout-button" style={{backgroundImage: `url(${iconGrid})`}} onClick={changeView} data-view="grid">Grid</div>
			<div className="layout-button" style={{backgroundImage: `url(${iconList})`}} onClick={changeView} data-view="list">List</div>
			<div className="layout-button" style={{backgroundImage: `url(${iconSlideshow})`}}>Slides</div>
			<div className="filter-toggle" style={{backgroundImage: `url(${iconFilter})`}} onClick={toggleFilter}>Filter</div>
		</div>
	);
};

CollectionLayout.propTypes = {
	changeView: PropTypes.func.isRequired,
	toggleFilter: PropTypes.func.isRequired,
	firstRecipe: PropTypes.object.isRequired
};

export default CollectionLayout;


/** WEBPACK FOOTER **
 ** ./src/components/collections/CollectionLayout.js
 **/